import { useRef, useState } from "react"
import { Box, IconButton, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { CopDocumentImportProgress } from "./server/cop-events.mjs"
import { Repeat } from "lib/@components/repeat"
import { CopImportProgressMessage } from "./cop-import-progress-message"

const REOPEN_DELAY_MS = 5000

export function CopImportProgressLog() {
    const [messages, setMessages] = useState([])
    const [hidden, setHidden] = useState(false)
    const hiddenAtRef = useRef(0)

    CopDocumentImportProgress.useEvent(handleMessage, [])

    if (messages.length === 0) return null
    if (hidden) return null

    return (
        <Box
            sx={{
                mb: 2,
                p: 1.5,
                bgcolor: "background.neutral",
                borderRadius: 1,
                border: "1px solid",
                borderColor: "divider",
                maxHeight: 200,
                overflowY: "auto",
                position: "relative",
            }}
        >
            <Typography variant="caption" fontWeight={600} sx={{ mb: 0.5, display: "block" }}>
                Import Progress
            </Typography>
            <IconButton
                aria-label="Hide import progress"
                size="small"
                onClick={handleHide}
                sx={{ position: "absolute", top: 4, right: 4 }}
            >
                <Iconify icon="mdi:close" sx={{ width: 16, height: 16 }} />
            </IconButton>
            <Repeat list={messages} item={<CopImportProgressMessage />} />
        </Box>
    )

    function handleMessage(data) {
        setMessages((prev) => [{ ...data, time: new Date() }, ...prev.slice(0, 49)])
        if (hidden && Date.now() - hiddenAtRef.current > REOPEN_DELAY_MS) {
            setHidden(false)
        }
    }

    function handleHide() {
        setHidden(true)
        hiddenAtRef.current = Date.now()
    }
}
